export enum UserRole {
  ADMIN = 'admin',
  APPROVER = 'approver',
  REVIEWER = 'reviewer',
  CM_PIC = 'cm_pic',
  ISSUER = 'issuer'
}

export enum IssueStatus {
  DRAFT = 'draft',
  WAITING_RESPONSE = 'waiting_response',
  WAITING_REVIEW = 'waiting_review',
  WAITING_APPROVAL = 'waiting_approval',
  COMPLETED = 'completed'
}

export enum IssueType {
  PRODUCT = 'product',
  PROCESS = 'process'
}

export enum IssueRank {
  A = 'a',
  B = 'b',
  C = 'c'
}

export interface User {
  id: number;
  email: string;
  full_name: string;
  roles: UserRole[];
  is_active: boolean;
}

export interface Project {
  id: number;
  code: string;
  name: string;
  description?: string;
  status: boolean;
  created_on: string;
  created_by: number;
}

export interface ProjectWithCount extends Project {
  lines_count: number;
  issues_count: number;
}

export interface Line {
  id: number;
  project_id: number;
  name: string;
  description?: string;
  status: boolean;
}

export interface LineWithCount extends Line {
  issues_count: number;
}

export interface IssuePhoto {
  id: number;
  issue_id: number;
  file_name: string;
  file_extension: string;
  uploaded_on: string;
}

export interface IssueHistory {
  id: number;
  issue_id: number;
  status: IssueStatus;
  comment?: string;
  created_on: string;
  created_by: number;
}

export interface Issue {
  id: number;
  project_id: number;
  line_id: number;
  type: IssueType;
  rank: IssueRank;
  part_number: string;
  problem: string;
  counter_measure?: string;
  final_counter_measure?: string;
  status: IssueStatus;
  created_on: string;
  created_by: number;
}

export interface IssueDetail extends Issue {
  photos: IssuePhoto[];
  history: IssueHistory[];
}
